import React, { useState } from "react";
import { View, Text, Image } from "react-native";

import { DEVICE_SIZES } from "rn-responsive-styles";
import { AppFontStyle } from "../../styles/AppFontStyle";

import withErrorBoundary from "../../utility/auth/withErrorBoundary";
import { AppImages } from "../../utility/AppImages";
import { AppColors } from "../../utility/AppColors";
import { TouchableOpacity } from "react-native";
import AddMemberContactModal from "../../screens/Auth/WebScreens/ChatScreen/AddMemberModal";

const ChatModalHeader = ({ deviceSize, currentChat, selectionMode }) => {
  const [isModalVisible, setModalVisible] = useState(false);
  return (
    <View
      style={{
        flexDirection: "row",
        paddingHorizontal: 10,
        justifyContent: "space-between",
      }}
    >
      <View>
        <Text
          style={[
            deviceSize === DEVICE_SIZES.XL
              ? AppFontStyle.BOLD_ANYBODY_24
              : AppFontStyle.BOLD_ANYBODY_20,
            { flex: 1, marginVertical: 20 },
          ]}
        >
          Chats
        </Text>
      </View>

      {!selectionMode && currentChat.type === "group" && (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            source={AppImages.icPin}
            style={{
              width: 40,
              height: 25,
              borderRadius: 20,
              resizeMode: "contain",
            }}
          />
          <TouchableOpacity
            onPress={() => setModalVisible(true)}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 5,
            }}
          >
            <View
              style={{
                height: 24,
                width: 24,
                borderRadius: 100,
                backgroundColor: AppColors.appGreenColor_51AF07,
              }}
            >
              <Image
                source={AppImages.icPlus}
                style={{ tintColor: "black", height: 24, width: 24 }}
                resizeMode="contain"
              />
            </View>

            <Text style={[AppFontStyle.BOLD_ANYBODY_14, {}]}>Add Members</Text>
          </TouchableOpacity>
        </View>
      )}
      <AddMemberContactModal
        isVisible={isModalVisible}
        onClose={() => setModalVisible(false)}
      />
    </View>
  );
};

export default withErrorBoundary(ChatModalHeader);
